export function bulkCandidates<T extends { field: string; label: string; confidence: number }>(suggestions: T[]): T[] {
  return suggestions.filter(
    (s) =>
      s.confidence >= 0.9 &&
      (s.field === 'tag' ||
        new Set(suggestions.filter((other) => other.field === s.field).map((other) => other.label)).size === 1),
  );
}
